module.exports = __webpack_public_path__ + "img/AdobeStock_249958779.934bcd73.jpeg";